{
  "management": "Scorekortshantering",
  "create_manage_scorecards": "Skapa och hantera golfbanornas scorekort",
  "create_new_scorecard": "Skapa nytt scorekort",
  "edit_scorecard": "Redigera scorekort",
  "search_scorecards": "Sök efter bannamn eller stad...",
  "no_scorecards_found": "Inga scorekort hittades",
  "tee_sets": "Teeuppsättningar",
  "course_info": "Baninfo",
  "hole_config": "Hål",
  "tee_set_config": "Tees",
  "review": "Granska",
  "course_information": "Baninformation",
  "number_of_holes": "Antal hål",
  "use_current_location": "Använd nuvarande plats",
  "hole_configuration": "Hålkonfiguration",
  "auto_assign": "Tilldela automatiskt",
  "total_par": "Total par",
  "par_distribution": "Par-fördelning",
  "par_3": "Par 3",
  "par_4": "Par 4",
  "par_5": "Par 5",
  "par_6": "Par 6",
  "tee_set_configuration": "Teeuppsättningskonfiguration",
  "at_least_one_tee_set": "Minst en teeuppsättning krävs",
  "add_tee_set": "Lägg till teeuppsättning",
  "tee_name": "Teenamn",
  "color": "Färg",
  "black": "Svart",
  "gold": "Guld",
  "blue": "Blå",
  "white": "Vit",
  "yellow": "Gul",
  "red": "Röd",
  "green": "Grön",
  "orange": "Orange",
  "purple": "Lila",
  "championship": "Mästerskap",
  "tee_set": "Teeuppsättning",
  "select_tee_set": "Välj tee-set",
  "course_rating_male": "CR (herrar)",
  "slope_rating_male": "Slope (herrar)",
  "course_rating_female": "CR (damer)",
  "slope_rating_female": "Slope (damer)",
  "hole_distances": "Hålavstånd (meter)",
  "total_distance": "Total distans",
  "meters": "meter",
  "remove_tee_set": "Ta bort teeuppsättning",
  "review_confirm": "Granska och bekräfta",
  "review_configuration": "Granska din scorekortkonfiguration innan du sparar",
  "coordinates": "Koordinater",
  "hcp": "HCP",
  "confirm_delete_scorecard": "Är du säker på att du vill ta bort detta scorekort?",
  "scorecard_created_successfully": "Scorekort skapades framgångsrikt",
  "scorecard_updated_successfully": "Scorekort uppdaterades framgångsrikt",
  "scorecard_deleted_successfully": "Scorekort togs bort framgångsrikt",
  "status_updated_successfully": "Status uppdaterades framgångsrikt",
  "failed_to_load_scorecards": "Misslyckades att ladda scorekort",
  "failed_to_load_scorecard_details": "Misslyckades att ladda scorekortsdetaljer",
  "failed_to_save_scorecard": "Misslyckades att spara scorekort",
  "failed_to_delete_scorecard": "Misslyckades att ta bort scorekort",
  "failed_to_update_status": "Misslyckades att uppdatera status",
  "no_holes_configured": "Inga hål konfigurerade ännu. Klicka på 'Initiera hål' för att skapa dem.",
  "initialize_holes": "Initiera hål",
  "scorecards_activated": "{{count}} resultatkort aktiverade",
  "scorecards_deactivated": "{{count}} resultatkort inaktiverade",
  "scorecards_deleted": "{{count}} resultatkort borttagna",
  "failed_to_activate": "Aktivering misslyckades",
  "failed_to_deactivate": "Inaktivering misslyckades",
  "failed_to_delete_scorecards": "Borttagning av resultatkort misslyckades",
  "delete_scorecards": "Ta bort resultatkort",
  "confirm_delete_scorecards": "Vill du verkligen ta bort {{count}} resultatkort?",
  "owner_tenant": "Ägarklubb",
  "no_owner": "Ingen ägare",
  "owned_by": "Ägare: {{name}}",
  "visible_to_other_tenants": "Synlig för andra klubbar",
  "shared_with": "Synlig för klubbar: {{names}}",
  "shared_tenants": "Synlighet för andra klubbar",
  "shared_tenants_placeholder": "Välj klubbar...",
  "import_ebirdie": "Importera från eBirdie",
  "import_ebirdie_title": "Importera bana från eBirdie",
  "import_ebirdie_confirm": "Importera",
  "import_ebirdie_failed": "Import av bana från eBirdie misslyckades",
  "select_tenant": "Välj klubb",
  "ebirdie_course": "eBirdie-bana",
  "search_ebirdie_courses": "Sök på banans eller klubbens namn...",
  "select_ebirdie_course": "Välj bana",
  "no_shared_tenants_available": "Inga alternativ"
}
